import Emitter from "./Emitter";

export default class SetLaunchUrl extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default(payload) {
        this.emitGame({ wpgaction: "setLaunchUrlFromWallet", data: { "gameUrl": payload.data.gameLaunchUrl, "refId": payload.data.refId } });
    }
}
